import { Button } from "@/components/base/buttons/button";
import { useFormContext } from "..";

type SubmitButtonProps = {
	children: React.ReactNode;
};

export const SubmitButton = ({ children }: SubmitButtonProps) => {
	const form = useFormContext();

	return (
		<form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
			{([canSubmit, isSubmitting]) => (
				<Button
					type="submit"
					disabled={!canSubmit || isSubmitting}
					className={`submit-button ${
						isSubmitting ? "submit-button--loading" : ""
					}`}
				>
					{isSubmitting ? "Loading..." : children}
				</Button>
			)}
		</form.Subscribe>
	);
};
